import { useEffect } from "react"

import { Card, Layout, Spin } from "antd"
import { connect } from "react-redux"
import { useNavigate } from "react-router-dom"

import NewPasswordAdminForm from "../Components/Forms/NewPasswordAdminForm"
import LoginHeader from "../Components/LoginHeader"
import AuthActions from "./LoginPage/reducer"

function NewPasswordAdminPage({ error, fetching, tempEmail, ...props }) {
  const navigate = useNavigate()

  function handleSubmit(data) {
    if (fetching) return
    const newData = {
      email: tempEmail,
      current_password: data?.current,
      new_password: data?.password
    }
    props.changeAdminPassword(newData)
  }

  useEffect(() => {
    document.title = "Change Admin Password - Chargeback"
    if (!tempEmail) {
      navigate("/login")
    }
  }, [])

  useEffect(() => {
    if (error) props.resetError()
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [error])

  return (
    <Layout>
      <Spin size="large" spinning={fetching}>
        <div className="login-row">
          <LoginHeader />
          <div className="login-content">
            <div className="content-main sign-up">
              <Card className="login-card">
                <h2 className="card-title">Change password</h2>
                <h4 className="card-subtitle-signup">
                  Admins are required to update their password every 60 days. Please choose a new
                  password that you haven't used before.
                </h4>
                <NewPasswordAdminForm onSubmit={handleSubmit} error={error} />
              </Card>
            </div>
          </div>
        </div>
      </Spin>
    </Layout>
  )
}

const mapStateToProps = (state) => ({
  error: state.auth.error,
  tempEmail: state.auth.tempEmail,
  fetching: state.auth.fetching,
  isMobile: state.nav.isMobile
})

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  resetError: () => dispatch(AuthActions.authErrorReset()),
  changeAdminPassword: (params) => dispatch(AuthActions.changeAdminPasswordRequest(params))
})

export default connect(mapStateToProps, mapDispatchToProps)(NewPasswordAdminPage)
